import { get } from "../../../server/actions";
export const getManageSchoolSettingList=(schoolId)=>{        
    return get('/schoolYears/search/findByMealSchoolSchoolId?mealSchoolId=' + schoolId + '&access_token=')
}

export const setSchoolYearSettingsToSession=(schoolId,list)=>{
    if(list){
        sessionStorage.setItem('schoolYearsList', JSON.stringify(list));
    }else{
        getManageSchoolSettingList(schoolId).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {       
            sessionStorage.setItem('schoolYearsList', JSON.stringify((data._embedded || {}).schoolYears || []));
        }).catch((error) => {                
            console.log('Get manage school response', error)
        })
    }
}

// Resolves the schoolYear record matching the year the user is currently working in
// (sessionStorage 'schoolYearValue'). Spring Data REST omits _embedded entirely when
// the collection is empty, so it has to be guarded. Resolves to {} when there is no
// matching record.
export const getActiveSchoolYearSettings = (schoolId) => {
    return getManageSchoolSettingList(schoolId).then((response) => {
        if (!response.ok) {
            throw Error(response.statusText);
        }
        return response.json();
    }).then((data) => {
        const activeSchoolYear = sessionStorage.getItem('schoolYearValue') || '';
        return ((data._embedded || {}).schoolYears || []).find(sy => sy.schoolYear == activeSchoolYear) || {};
    });
}



// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/ManageSchools/manageSchoolSettings.js